import {
  GET_POLICIES,
  GET_POLICIES_SUCCESS,
  GET_POLICIES_ERROR,
  ADD_POLICY,
  ADD_POLICY_SUCCESS,
  ADD_POLICY_ERROR,
  GET_POLICY,
  GET_POLICY_SUCCESS,
  GET_POLICY_ERROR,
  UPDATE_POLICY,
  UPDATE_POLICY_SUCCESS,
  UPDATE_POLICY_ERROR,
  DELETE_POLICY,
  DELETE_POLICY_SUCCESS,
  DELETE_POLICY_ERROR,
  TOGGLE_POLICY_MODAL,
  GET_DEFAULT_POLICY,
  GET_DEFAULT_POLICY_SUCCESS,
  GET_DEFAULT_POLICY_ERROR,
  SEND_CONTACT_US_MESSAGE,
  SEND_DELETE_ACCOUNT_REQUEST,
} from "./actionTypes";

export const getPolicies = (request) => {
  return {
    type: GET_POLICIES,
    payload: { request },
  };
};

export const getPoliciesSuccess = (policies) => {
  return {
    type: GET_POLICIES_SUCCESS,
    payload: policies,
  };
};

export const getPoliciesError = (message) => {
  return {
    type: GET_POLICIES_ERROR,
    payload: message,
  };
};

export const addPolicy = (request) => {
  return {
    type: ADD_POLICY,
    payload: { request },
  };
};

export const addPolicySuccess = () => {
  return {
    type: ADD_POLICY_SUCCESS,
  };
};

export const addPolicyError = (error) => {
  return {
    type: ADD_POLICY_ERROR,
    payload: error,
  };
};

export const getPolicy = (id) => {
  return {
    type: GET_POLICY,
    payload: { id },
  };
};

export const getPolicySuccess = (policy) => {
  return {
    type: GET_POLICY_SUCCESS,
    payload: policy,
  };
};

export const getPolicyError = (message) => {
  return {
    type: GET_POLICY_ERROR,
    payload: message,
  };
};

export const getDefaultPolicy = () => {
  return {
    type: GET_DEFAULT_POLICY,
  };
};

export const getDefaultPolicySuccess = (policy) => {
  return {
    type: GET_DEFAULT_POLICY_SUCCESS,
    payload: policy,
  };
};

export const getDefaultPolicyError = (message) => {
  return {
    type: GET_DEFAULT_POLICY_ERROR,
    payload: message,
  };
};

export const updatePolicy = (request) => {
  return {
    type: UPDATE_POLICY,
    payload: { request },
  };
};

export const updatePolicySuccess = () => {
  return {
    type: UPDATE_POLICY_SUCCESS,
  };
};

export const updatePolicyError = (error) => {
  return {
    type: UPDATE_POLICY_ERROR,
    payload: error,
  };
};

export const deletePolicy = (id) => {
  return {
    type: DELETE_POLICY,
    payload: { id },
  };
};

export const deletePolicySuccess = () => {
  return {
    type: DELETE_POLICY_SUCCESS,
  };
};

export const deletePolicyError = (error) => {
  return {
    type: DELETE_POLICY_ERROR,
    payload: error,
  };
};

export const togglePolicyModalAction = () => {
  return {
    type: TOGGLE_POLICY_MODAL,
  };
};

export const sendContactUsMessage = (message) => {
  return {
    type: SEND_CONTACT_US_MESSAGE,
    payload: { message },
  };
};

export const sendDeleteAccountRequest = (request) => {
  return {
    type: SEND_DELETE_ACCOUNT_REQUEST,
    payload: { request },
  };
};
